<table class="weekdaytable">
  <tr>
    <td>{{"Mn"|translate}}</td>
    <td>{{"Tu"|translate}}</td>
    <td>{{"Wd"|translate}}</td>
    <td>{{"Th"|translate}}</td>
    <td>{{"Fr"|translate}}</td>
    <td>{{"St"|translate}}</td>
    <td>{{"Sn"|translate}}</td>
  </tr>
  <tr>
    <!--///TODO use const values somehow, Luke-->
   <td><input type="checkbox" [checked]="isDayChecked(1)"  (change)="onCheckboxChange(1,$event)" /></td>
    <td><input type="checkbox" [checked]="isDayChecked(2)"  (change)="onCheckboxChange(2,$event)" /></td>
    <td><input type="checkbox" [checked]="isDayChecked(4)"  (change)="onCheckboxChange(4,$event)" /></td>
    <td><input type="checkbox" [checked]="isDayChecked(8)"  (change)="onCheckboxChange(8,$event)" /></td>
    <td><input type="checkbox" [checked]="isDayChecked(16)" (change)="onCheckboxChange(16,$event)" /></td>
    <td><input type="checkbox" [checked]="isDayChecked(32)" (change)="onCheckboxChange(32,$event)" /></td>
    <td><input type="checkbox" [checked]="isDayChecked(64)" (change)="onCheckboxChange(64,$event)" /></td>

  </tr>
</table>